import {ProductsOne} from '../../graphql/types/ventasType'
import {parsePrice} from '../../helpers'
import {COLOR_PRIMARY} from '../../helpers/consts'

export const ViewConcepts = ({data, client}: {data: ProductsOne; client: string}) => {
  if (data.edges.length === 0) {
    return (
      <>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            borderBottom: `1px solid ${COLOR_PRIMARY}`,
            height: '45px',
          }}
        >
          <div style={{flex: 1, padding: '12px'}}>
            <span style={{top: '0', position: 'absolute', fontWeight: '500'}}>CONCEPTO:</span>
            <span style={{textTransform: 'uppercase', fontSize: '20px', marginLeft: '100px'}}>
              No aplica
            </span>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            borderBottom: `1px solid ${COLOR_PRIMARY}`,
            height: '45px',
          }}
        >
          <div style={{flex: 1, padding: '12px', fontSize: '20px'}}>
            <span
              style={{
                width: '100%',
                borderBottom: '2px dashed black',
                margin: '0 5px 11px 0',
                display: 'inline-block',
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            borderBottom: `1px solid ${COLOR_PRIMARY}`,
            height: '45px',
          }}
        >
          <div style={{flex: 1, padding: '12px'}}>
            <span
              style={{
                width: '100%',
                borderBottom: '2px dashed black',
                margin: '5px 5px 11px 0',
                display: 'inline-block',
              }}
            />
          </div>
        </div>
      </>
    )
  }
  const infoConcept = data.edges
    .map(({node}) => {
      const text = `${node.units} ${node.product.unitType} de ${node.product.name}, ${parsePrice(
        `${Number(node.price) - Number(node.promotion)}`
      )} c/u`
      return text
    })
    .concat(client)
  const divs: string[][] = [[], [], []]

  infoConcept.forEach((item, index) => {
    divs[index % 3].push(item)
  })
  return (
    <>
      <div
        style={{
          position: 'relative',
          display: 'flex',
          borderBottom: `1px solid ${COLOR_PRIMARY}`,
          height: '45px',
        }}
      >
        <div style={{flex: 1, padding: '12px'}}>
          <span style={{top: '0', position: 'absolute', fontWeight: '500'}}>CONCEPTO:</span>
          <span
            style={{
              textTransform: 'uppercase',
              fontSize:
                infoConcept.length <= 3 ? '20px' : infoConcept.length <= 6 ? '13px' : '10px',
              marginLeft: infoConcept.length > 3 ? '3px' : '100px',
            }}
          >
            {divs[0].map((str) => str + '.  ')}
          </span>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          borderBottom: `1px solid ${COLOR_PRIMARY}`,
          height: '45px',
        }}
      >
        <div
          style={{
            flex: 1,
            padding: '12px',
            fontSize: infoConcept.length <= 3 ? '20px' : infoConcept.length <= 6 ? '13px' : '10px',
          }}
        >
          <span
            style={{
              textTransform: 'uppercase',
              fontSize:
                infoConcept.length <= 3 ? '20px' : infoConcept.length <= 6 ? '13px' : '10px',
            }}
          >
            {divs[1].map((str) => str + '.  ')}
          </span>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          borderBottom: `1px solid ${COLOR_PRIMARY}`,
          height: '45px',
        }}
      >
        <div style={{flex: 1, padding: '12px'}}>
          <span
            style={{textTransform: 'uppercase', fontSize: infoConcept.length > 3 ? '14px' : '20px'}}
          >
            {divs[2].map((str) => str + '.  ')}
          </span>
        </div>
      </div>
    </>
  )
}
